import { Card, CardHeader, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { CompanyType, ObjectType, IssueType as PlanningIssueType } from '@tom-ui/planning/app/api'
import { YardIssueTypeDummy } from '@tom-ui/yard'
import { observer } from 'mobx-react-lite'
import { IssueType as OperationIssueType } from 'modules/operations/src/app/api'
import { AggregateIssuesViewStore } from '../../Stores/AggregateIssuesViewStore'

export type IssueTypeSummary = {
  key: PlanningIssueType | OperationIssueType | YardIssueTypeDummy
  companyType?: CompanyType
  translationKey: string
  objectType?: ObjectType
  count: number
}

type Props = {
  viewStore: AggregateIssuesViewStore
  issueTypeSummary: IssueTypeSummary
}

export const IssuesTypeSummaryCard = observer(({ viewStore, issueTypeSummary }: Props) => {
  const { t } = useTranslate()

  return (
    <Card
      sx={{ cursor: 'pointer' }}
      onClick={() => {
        viewStore.setSelectedIssueType(issueTypeSummary.key)
        viewStore.setSelectedIssueCompanyType(issueTypeSummary.companyType)
        viewStore.setSelectedIssueObjectType(issueTypeSummary.objectType)
      }}
      data-cy={`${issueTypeSummary.key.toLowerCase()}-issue-card`}
    >
      <CardHeader
        sx={{ padding: '16px !important' }}
        title={<Typography variant='h4'>{t(issueTypeSummary.translationKey)}</Typography>}
        subheader={t('issuesCount', '{count} issues', { count: issueTypeSummary.count })}
      />
    </Card>
  )
})
